<mat-card-actions class="mb-0 pb-0 w-100 d-flex justify-content-between">
  <div>
    <button
      *ngIf="secondaryTitle"
      class="mb-1 mr-2"
      mat-button
      [disabled]="!isSecondaryEnabled"
      (click)="onClickSecondary()"
    >
      {{ secondaryTitle | translate }}
    </button>
  </div>
  <div>
    <button
      *ngIf="optionalTitle"
      class="mb-1 mr-2"
      mat-stroked-button
      type="submit"
      [disabled]="!isOptionalEnabled || isSpinnerLoading"
      (click)="onClickOptional()"
    >
      <ng-container
        *ngIf="isOptionalEnabled && isSpinnerLoading; else optionalNameOnly"
      >
        <span class="button-with-spinner">
          <mat-spinner diameter="20" strokeWidth="4"></mat-spinner>
        </span>
      </ng-container>

      <ng-template #optionalNameOnly>
        {{ optionalTitle | translate }}
      </ng-template>
    </button>
    <button
      *ngIf="primaryTitle"
      class="mb-1 mr-2"
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!isPrimaryEnabled || isSpinnerLoading"
      (click)="onClickPrimary()"
    >
      <ng-container
        *ngIf="isSecondaryEnabled && isSpinnerLoading; else nameOnly"
      >
        <span class="button-with-spinner">
          <mat-spinner diameter="20" strokeWidth="4"></mat-spinner>
        </span>
      </ng-container>

      <ng-template #nameOnly>
        {{ primaryTitle | translate }}
      </ng-template>
    </button>
  </div>
</mat-card-actions>
